var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#3767F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 18.6667H13.3333C12.597 18.6667 12 19.2636 12 20V22.6667C12 23.4031 12.597 24 13.3333 24H34.6667C35.403 24 36 23.4031 36 22.6667V20C36 19.2636 35.403 18.6667 34.6667 18.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6667V36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3327 24V33.3333C33.3327 34.0406 33.0517 34.7189 32.5516 35.219C32.0515 35.719 31.3733 36 30.666 36H17.3327C16.6254 36 15.9472 35.719 15.4471 35.219C14.947 34.7189 14.666 34.0406 14.666 33.3333V24",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 18.6667C17.1153 18.6667 16.2674 18.3155 15.6423 17.6904C15.0172 17.0652 14.666 16.2174 14.666 15.3333C14.666 14.4493 15.0172 13.6014 15.6423 12.9763C16.2674 12.3512 17.1153 12 17.9993 12C19.2856 11.9776 20.546 12.6017 21.6163 13.7909C22.6866 14.9801 23.5171 16.6792 23.9993 18.6667C24.4816 16.6792 25.3121 14.9801 26.3824 13.7909C27.4526 12.6017 28.7131 11.9776 29.9993 12C30.8834 12 31.7313 12.3512 32.3564 12.9763C32.9815 13.6014 33.3327 14.4493 33.3327 15.3333C33.3327 16.2174 32.9815 17.0652 32.3564 17.6904C31.7313 18.3155 30.8834 18.6667 29.9993 18.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9cb97880.svg";
export { ForwardRef as ReactComponent };